// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqRequestQuoteSpecificationsStyles } from "@bg/Overrides/Widgets/RfqRequestQuote/RfqRequestQuoteSpecifications";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { css } from "styled-components";

rfqRequestQuoteSpecificationsStyles.notesTextArea = {
    cssOverrides: {
        formField: css`
            margin-right: 15px;
            max-width: 323px;
            label {
                font-weight: ${fontConfig.weight.semiBold};
            }
            textarea::placeholder {
                opacity: 0.6;
            }
            &&& textarea {
                padding: 6px;
                max-height: 36px !important;
            }
            margin-top: -24px;
            @media (max-width: 900px) {
                max-width: unset;
            }
            @media (max-width: 520px) {
                margin-right: 0px;
                margin-bottom: 15px;
            }
        `,
        inputSelect: css`
            resize: none;
        `,
    },
};
